import styled from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';

export const Header = styled.div`
  width: 90%;
  align-self: flex-end;
  margin-bottom: 38px;

  @media(min-width: 480px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Isotipo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 18px;

  @media(min-width: 480px) {
    display: inline-block;
    margin: 0 20px 0 0;
  }
`;

export const Title = styled.span`
  display: block;
  font-family: ${FONTS.MULI_REGULAR};
  font-size: 32px;
  color: ${COLORS.BLACK};
  text-align: center;

  @media(min-width: 480px) {
    display: inline-block;
  }
`;

export const FormStyled = styled.form`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 280px;
  background: ${COLORS.WHITE};
  padding: 13px 15px 23px;
  box-sizing: border-box;
  border-radius: 4px;
  align-self: flex-start;

  @media (min-width: 480px) {
    width: 400px;
    padding: 28px 50px 38px;
  }
`;

export const Error = styled.div`
  width: 100%;
  height: 20px;
  text-align: center;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.ERROR_RED};
`;

export const Msg = styled.div`
  width: 100%;
  height: 20px;
  text-align: center;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${({ msgType }) => {(msgType === 'info' ? COLORS.AQUA_BLUE : COLORS.ERROR_RED)}}
`;

export const SubTitle = styled.h2`
  font-family: ${FONTS.ROBOTO_REGULAR};
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  color: #000000;
  width: 100%;
`;

export const Text = styled.p`
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  margin: 20px 0;
`;

export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 27px;
  width: 100%;
`;

export const Link = styled.span`
  font-family: ${FONTS.ROBOTO_REGULAR};
  width: 100%;
  font-size: 14px;
  line-height: 16px;
  text-decoration-line: underline;
  color: #000000;
  cursor: pointer;
  text-align: center;
`;


export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  margin-top: 10px;
  button {
    flex: 1;
  }
`;
